/*
 * Products with variants open the theme's quick-add modal (with the option
 * dropdown) from the collection card. Releasit does not mount its "Poruči odmah"
 * button inside that modal, so we add an identical one. It opens the product
 * page with the chosen variant and #poruci, where Releasit's own product button
 * is clicked automatically: the same order flow as buying from the product page.
 */
(function () {
  var ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false" class="breskva-buy-now__icon"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/></svg>';
  var RELEASIT_PRODUCT_BTN = '._rsi-buy-now-button-product, #rsi_buy_now_button';
  var lastProductUrl = null;

  // Remember which card opened the modal, so the modal button knows the product page.
  document.addEventListener(
    'click',
    function (e) {
      var opener = e.target.closest('[data-product-url]');
      if (opener) lastProductUrl = opener.getAttribute('data-product-url');
    },
    true
  );

  function addButton(info) {
    if (info.querySelector('.breskva-buy-now--modal')) return;
    if (info.querySelector(RELEASIT_PRODUCT_BTN)) return;
    var atc = info.querySelector('form[action$="/cart/add"] button[name="add"]');
    if (!atc) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'breskva-buy-now breskva-buy-now--modal';
    btn.innerHTML = ICON + '<span>Poruči odmah</span>';
    atc.insertAdjacentElement('afterend', btn);
  }

  // Benefit lines that start with an emoji ("✅ Plaćanje pouzećem — ...") on the
  // product page and in the quick-add modal: put the emoji in its own box so a
  // wrapped second line starts under the text, not under the emoji
  // (styles: .bk-emoji-line in releasit-override.css).
  var EMOJI_START = /^\s*((?:\p{Extended_Pictographic}|\p{Regional_Indicator})(?:\uFE0F|\u200D\p{Extended_Pictographic})*)\s*/u;
  function splitEmojiLine(p) {
    p.setAttribute('data-bk-emoji', '');
    var first = p.firstChild;
    while (first && first.nodeType === 3 && !first.nodeValue.trim()) first = first.nextSibling;
    if (!first || first.nodeType !== 3) return;
    var m = first.nodeValue.match(EMOJI_START);
    if (!m) return;
    first.nodeValue = first.nodeValue.slice(m[0].length);
    var text = document.createElement('span');
    text.className = 'bk-emoji-line__text';
    while (first.previousSibling) p.removeChild(first.previousSibling);
    while (p.firstChild) text.appendChild(p.firstChild);
    var icon = document.createElement('span');
    icon.className = 'bk-emoji-line__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = m[1];
    p.appendChild(icon);
    p.appendChild(text);
    p.classList.add('bk-emoji-line');
  }

  var queued = false;
  function scan() {
    queued = false;
    document.querySelectorAll('.quick-add-modal__content-info').forEach(addButton);
    document.querySelectorAll('.emoji-benefits-container p:not([data-bk-emoji])').forEach(splitEmojiLine);
    document.querySelectorAll('product-recommendations .quick-add product-form').forEach(addRelatedButton);
  }

  // Cards in "Možda će vam se dopasti" load after Releasit has started, so it
  // never mounts its button there. Give them the same green button, which opens
  // the product page with #poruci (Releasit form opens there, see below).
  function addRelatedButton(productForm) {
    var quickAdd = productForm.closest('.quick-add');
    if (!quickAdd || quickAdd.querySelector('._rsi-buy-now-button, .breskva-buy-now')) return;
    var card = productForm.closest('.card-wrapper, .card');
    var link = card && card.querySelector('a[href*="/products/"]');
    if (!link) return;
    var a = document.createElement('a');
    a.className = 'breskva-buy-now breskva-buy-now--related';
    a.href = link.getAttribute('href').split('?')[0].split('#')[0] + '#poruci';
    a.style.textDecoration = 'none';
    a.innerHTML = ICON + '<span>Poruči odmah</span>';
    productForm.insertAdjacentElement('afterend', a);
  }
  scan();
  new MutationObserver(function () {
    if (!queued) {
      queued = true;
      requestAnimationFrame(scan);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('.breskva-buy-now--modal');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var info = btn.closest('.quick-add-modal__content-info');
      var form = info.querySelector('form[action$="/cart/add"] button[name="add"]').form;
      var id = form.querySelector('input[name="id"]').value;
      var url = lastProductUrl || (info.querySelector('a[href*="/products/"]') || {}).getAttribute?.('href');
      if (!url) return;
      btn.disabled = true;
      window.location.href = url.split('?')[0].split('#')[0] + '?variant=' + encodeURIComponent(id) + '#poruci';
    },
    true
  );

  // Product page opened with #poruci: click Releasit's own button once it renders.
  if (window.location.hash === '#poruci') {
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      var rsi = Array.prototype.find.call(document.querySelectorAll(RELEASIT_PRODUCT_BTN), function (el) {
        return el.offsetParent && !el.closest('#CartDrawer');
      });
      if (rsi || tries > 40) {
        clearInterval(timer);
        history.replaceState(null, '', window.location.pathname + window.location.search);
        if (rsi) rsi.click();
      }
    }, 250);
  }
})();
